import { hirerExpAxiosInstance } from './apiInstance';
import { DefaultDelay, retrier } from './apiRetry';
import type { SearchResponse } from './models';

import type { RecommendedQuestion } from '.';

export const search = async (
  query: string,
  country: string,
  shownQuestions: RecommendedQuestion[],
  languageId: string,
  questionnaireId: string,
): Promise<SearchResponse> => {
  const result = await retrier(
    () =>
      hirerExpAxiosInstance().post(`/search/questions`, {
        keywords: query,
        country,
        languageId,
        questionnaireId,
        selectedQuestionIds: shownQuestions.map((q) => ({ id: q.id })),
      }),
    {
      strategy: 'fixed',
      delayMs: DefaultDelay,
    },
  );

  return result.data;
};
